<template>
  <!-- /newscreen/env/getAllHistoryByType -->
  <div class="sewageDeal" ref="sewageDeal">
    <div class="tab">
      <div class="switch-tab">
        <div class="tab-list" :class="index == curTab ? 'active' : ''" @click="switchTab(index, item)" v-for="(item, index) in tabList" :key="index">
          {{ item }}
        </div>
      </div>
      <div class="historyButton" @click="historicalTrendCheck">历史趋势</div>
      <div class="view-more" @click="lookMoreCheck">查看所有 ☰</div>
      <!-- <img src="./img/more.png" alt="all"> -->
    </div>
    <el-carousel indicator-position="outside" height="168px" :interval="10000" :initial-index="0" :loop="true" :autoplay="true" arrow="never">
      <el-carousel-item v-for="(list, index) in dataArr" :key="index">
        <div class="main-wrap">
          <div class="histogram-list" v-for="(item, n) in list" :key="n">
            <div class="histogram-wrap">
              <div class="histogram-item" v-for="(bar, i) in item.list" :key="i">
                <div class="histogram-bar-name">{{ bar.value_name }}</div>
                <div class="histogram-bar-bg">
                  <div class="histogram-bar" :class="bar.barType" :style="{
                      width:
                        bar.barType == 'red'
                          ? '100%'
                          : (bar.value / bar.standard_data) * 1.2 * 100 + '%',
                    }"></div>
                </div>
                <div class="histogram-bar-value">{{ bar.value }}</div>
              </div>
            </div>
            <div class="histogram-title">{{ item.deviceName }}</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- <div class="change_button"></div> -->
  </div>
</template>

<script>
import historicalTrend3 from "./components/historicalTrend3";
import { mapState, mapGetters } from "vuex";
import showMorePage from "./components/showMorePage";
export default {
  props: ["matrix", "x", "y"],
  data() {
    return {
      customerId: this.$store.state.customerId,
      dataArr: [],
      tabList: [],
      curTab: 0,
      dataList: [],
      timer: null,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.sewageDeal).outerWidth();
    let h = $(that.$refs.sewageDeal).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    async getListData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let getQgDevicesByType =
        CONFIG.requestName + this.$apiOpt.getQgDevicesByType;
      let res = await this.$apiUtils.get(getQgDevicesByType, {
        customerId: this.customerId,
        type: 1,
      });

      if (res) {
        let arr = [];
        for (let key in res) {
          arr.push(key);
          for (let data of res[key]) {
            for (let item of data.list) {
              if (Number(item.standard_data) * 0.8 >= item.value) {
                item.barType = "blue";
              } else if (
                Number(item.standard_data) >= item.value &&
                item.value > item.standard_data * 0.8
              ) {
                item.barType = "yellow";
              } else {
                item.barType = "red";
              }
            }
          }
        }
        this.tabList = arr;
        this.dataList = res;
        this.dataArr = this.handlerFun(res[this.tabList[0]]);
        this.$nextTick(() => {
          $(".sewageDeal .el-carousel__indicator").eq(0).click();
        });
      }
      this.timer = setTimeout(() => {
        this.getListData()
      }, 1000 * 60);
    },
    handlerFun(data) {
      let result = [];
      if (data && data.length > 0) {
        for (var i = 0; i < data.length; i += 3) {
          result.push(data.slice(i, i + 3));
        }
      }

      return result;
    },
    historicalTrendCheck() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(historicalTrend3, this.dialogCompontent, this);
    },
    lookMoreCheck() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(showMorePage, this.dialogCompontent, this);
    },

    switchTab(index, name) {
      this.curTab = index;
      // this.dataArr = this.dataList[name]
      this.dataArr = this.handlerFun(this.dataList[name]);
    },
  },
};
</script>
<style lang="scss">
.sewageDeal {
  .el-carousel__indicators--outside button {
    background: #4be0ff !important;
    width: 41px;
    height: 3px;
    border-radius: 1px;
  }
}
</style>
<style lang="scss" scoped="scoped">
.sewageDeal {
  height: 250px;
  width: 900px;
  .tab {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .switch-tab {
      display: flex;
      align-items: center;
      .tab-list {
        height: 26px;
        background: rgba(0, 0, 0, 0.2);
        box-shadow: 0px 1px 0px 0px #5bb4ff;
        border-radius: 4px;
        margin-right: 10px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        line-height: 26px;
        padding: 0 10px;
        text-align: center;
        cursor: pointer;
      }
      .active {
        background: linear-gradient(138deg, #006dc9 0%, #00325d 100%);
        box-shadow: 0px 1px 0px 0px #5bb4ff, 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
      }
    }
  }
  .historyButton {
    font-size: 18px;
    line-height: 18px;
    color: #f4c48f;
    cursor: pointer;
    margin: 0 10px 0px 5px;
  }
  .view-more {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 400;
    color: #4be0ff;
    line-height: 18px;
    cursor: pointer;
    img {
      margin-left: 5px;
      width: 18px;
    }
  }
  .main-wrap {
    margin-top: 10px;
    height: calc(100% - 30px);
    width: 100%;
    display: flex;
    padding: 0 11px;
    box-sizing: border-box;
    // justify-content: space-between;
    .histogram-list {
      display: flex;
      flex-direction: column;
      width: 33.3%;
      flex-wrap: wrap;
      height: 148px;
      margin-right: 10px;
      background: url("./img/bg.png") no-repeat;
      background-size: contain;
      padding: 0 8px;
      .histogram-wrap {
        display: flex;
        // align-items: center;
        flex-direction: column;
        justify-content: center;
        flex: 1;
        .histogram-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          &:last-child {
            margin-bottom: 0;
          }
          .histogram-bar-name {
            font-size: 16px;
            font-weight: 400;
            color: #e4fcff;
            line-height: 16px;
            text-align: right;
            width: 80px;
            overflow: hidden;
            // text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 5px;
          }
          .histogram-bar-bg {
            flex: 1;
            position: relative;
            height: 20px;
            margin-right: 10px;
            background: rgba($color: #000000, $alpha: 0.3);
            border: 1px solid rgba($color: #000000, $alpha: 0.3);
            .histogram-bar {
              position: absolute;
              width: 0;
              left: 0;
              top: 1;
              height: 20px;
              background: linear-gradient(270deg, #d7f1ff 0%, #79a9ff 100%);
              border-radius: 0px 2px 2px 0px;
              transition: width 0.3s linear 0s;
            }
            .blue {
              background: linear-gradient(270deg, #d7f1ff 0%, #79a9ff 100%);
            }
            .yellow {
              background: linear-gradient(270deg, #faebcb 0%, #f4d29c 100%);
            }
            .red {
              background: linear-gradient(270deg, #ffb0b0 0%, #ff7878 100%);
            }
          }
          .histogram-bar-value {
            font-size: 16px;
            font-weight: 400;
            color: #99f5ff;
            line-height: 16px;
            width: 50px;
            text-align: right;
          }
        }
      }
      .histogram-title {
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #c0d5d9;
      }
    }
  }
  .change_button {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 41px;
    height: 3px;
    background: #4be0ff;
    border-radius: 1px;
    cursor: pointer;
  }
}
.yellow_color {
  color: #ffcb00;
}
</style>
